import React from 'react'
import WhatsNewContent from "../../content/home/whatsNew.mdx"
import "./homePanel.scss";

const whatsNewPanel =() => {
    return (<React.Fragment>
        <div>
            <div className="homePanel">
                <div>
                    <div className="cds--row">
                        <div className="cds--col-lg-4 cds--col-md-12 cds--col-sm-8">
                            <h2>What&#8217;s new?</h2>
                        </div>
                    </div> 
                    <WhatsNewContent />
                </div>
            </div>
        </div>
    </React.Fragment>
    )
}

export default whatsNewPanel;